export const fagerstromQuestions = [
  {
    id: 1,
    text_fr: "Le matin, combien de temps après votre réveil fumez-vous votre première cigarette ?",
    text_en: "How soon after you wake up do you smoke your first cigarette?",
    options: [
      { label_fr: "Dans les 5 minutes", label_en: "Within 5 minutes", points: 3 },
      { label_fr: "6 à 30 minutes", label_en: "6-30 minutes", points: 2 },
      { label_fr: "31 à 60 minutes", label_en: "31-60 minutes", points: 1 },
      { label_fr: "Après 60 minutes", label_en: "After 60 minutes", points: 0 }
    ]
  },
  {
    id: 2,
    text_fr: "Trouvez-vous difficile de vous abstenir de fumer dans les endroits où c'est interdit ?",
    text_en: "Do you find it difficult to refrain from smoking in places where it is forbidden?",
    options: [
      { label_fr: "Oui", label_en: "Yes", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  },
  {
    id: 3,
    text_fr: "À quelle cigarette renonceriez-vous le plus difficilement ?",
    text_en: "Which cigarette would you hate most to give up?",
    options: [
      { label_fr: "La première de la journée", label_en: "The first one in the morning", points: 1 },
      { label_fr: "N'importe quelle autre", label_en: "All others", points: 0 }
    ]
  },
  {
    id: 4,
    text_fr: "Combien de cigarettes fumez-vous par jour ?",
    text_en: "How many cigarettes a day do you smoke?",
    options: [
      { label_fr: "10 ou moins", label_en: "10 or less", points: 0 },
      { label_fr: "11 à 20", label_en: "11-20", points: 1 },
      { label_fr: "21 à 30", label_en: "21-30", points: 2 },
      { label_fr: "31 ou plus", label_en: "31 or more", points: 3 }
    ]
  },
  {
    id: 5,
    text_fr: "Fumez-vous à intervalles plus rapprochés durant les premières heures de la matinée que durant le reste de la journée ?",
    text_en: "Do you smoke more frequently during the first hours after waking than during the rest of the day?",
    options: [
      { label_fr: "Oui", label_en: "Yes", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  },
  {
    id: 6,
    text_fr: "Fumez-vous lorsque vous êtes malade au point de devoir rester au lit presque toute la journée ?",
    text_en: "Do you smoke if you are so ill that you are in bed most of the day?",
    options: [
      { label_fr: "Oui", label_en: "Yes", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  }
];

export const getScoreInterpretation = (score, language) => {
  if (score <= 2) {
    return {
      level: language === 'fr' ? 'Dépendance très faible' : 'Very low dependence',
      color: 'score-very-low',
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      message: language === 'fr' 
        ? "Félicitations ! Votre dépendance au tabac est très faible. C'est le moment idéal pour arrêter."
        : "Congratulations! Your tobacco dependence is very low. This is the perfect time to quit."
    };
  } else if (score <= 4) {
    return {
      level: language === 'fr' ? 'Dépendance faible' : 'Low dependence',
      color: 'score-low',
      bgColor: 'bg-green-200',
      textColor: 'text-green-900',
      message: language === 'fr'
        ? "Votre dépendance est faible. Vous avez de bonnes chances de réussir à arrêter."
        : "Your dependence is low. You have good chances of successfully quitting."
    };
  } else if (score === 5) {
    return {
      level: language === 'fr' ? 'Dépendance moyenne' : 'Medium dependence',
      color: 'score-medium',
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      message: language === 'fr'
        ? "Votre dépendance est modérée. Un soutien pourrait vous aider à arrêter."
        : "Your dependence is moderate. Support could help you quit."
    };
  } else if (score <= 7) {
    return {
      level: language === 'fr' ? 'Dépendance forte' : 'High dependence',
      color: 'score-high',
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-800',
      message: language === 'fr'
        ? "Votre dépendance est élevée. Consultez un professionnel pour vous accompagner."
        : "Your dependence is high. Consider consulting a professional for support."
    };
  } else {
    return {
      level: language === 'fr' ? 'Dépendance très forte' : 'Very high dependence',
      color: 'score-very-high',
      bgColor: 'bg-red-100',
      textColor: 'text-red-900',
      message: language === 'fr'
        ? "Votre dépendance est très élevée. Un accompagnement médical est recommandé."
        : "Your dependence is very high. Medical support is recommended."
    };
  }
};
